import type { ReactNode } from "react";

import { QUESTION_STATE } from "../lib/read";
import type { ChipState } from "../lib/read";
export type { ChipState };

export interface QuestionChipProps {
  /** The question's label on the page, for example "P". Never a grade. */
  label: string;
  state: ChipState;
  onSelect?: () => void;
}

const stateClass: Record<ChipState, string> = {
  right: "qchip-right",
  cause: "qchip-cause",
  "no-cause": "qchip-nocause",
  unread: "qchip-unread",
};

/* Drawn, not typed: a bar rather than a dash character, and a dot for a
   question we could not read. */
const glyph: Record<ChipState, ReactNode> = {
  right: (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path d="m3 7.4 2.6 2.8L11 4" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  cause: (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path d="M3.6 3.6 10.4 10.4M10.4 3.6 3.6 10.4" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
    </svg>
  ),
  "no-cause": (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path d="M3 7h8" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
    </svg>
  ),
  unread: (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
      <circle cx="7" cy="7" r="1.8" fill="currentColor" />
    </svg>
  ),
};

export function QuestionChip({ label, state, onSelect }: QuestionChipProps) {
  const classes = ["qchip", stateClass[state]].join(" ");
  const content = (
    <>
      <span aria-hidden="true">{glyph[state]}</span>
      <span>{label}</span>
      <span className="sr-only">{QUESTION_STATE[state]}</span>
    </>
  );
  if (!onSelect) return <span className={classes}>{content}</span>;
  return (
    <button type="button" className={`${classes} press-bounce`} onClick={onSelect}>
      {content}
    </button>
  );
}
